import { Injectable } from "@angular/core";
import { BehaviorSubject, tap, switchMap, Observable } from "rxjs";
import { GlobalComponent } from "src/app/global-component";
import { ContactBaseModel } from "../../models/contact/contact-base.model";
import { EmailTemplateBaseModel } from "../../models/emailTemplates/email-template.model.ts";
import { SearchResultModel } from "../../models/query/search-result-model";
import { MyfileApiService } from "../myfile-api.service";
import { BaseListService } from "./base-list.service";
import { EmailTemplateSearchModel } from "../../models/emailTemplates/email-template-search.model";

export class EmailListState extends EmailTemplateSearchModel {

}


@Injectable({ providedIn: 'root' })
export class EmailTemplateListService extends BaseListService {

    defaultEmailTemplateListState: EmailListState = {
        sortColumnDirective: '',
        sortDirectionDirective: '',
        pageSize: GlobalComponent.defaultPagingInfo.pageSize,
        pageIndex: 0,
        startIndex: 0,
        searchTerm: '',
        sortColumn: '',
        sortDirection: ''
    };

    private _resultItems$ = new BehaviorSubject<EmailTemplateBaseModel[]>([]);

    protected override _state: EmailListState = { ...this.defaultEmailTemplateListState };

    constructor(
        private myFileApiService: MyfileApiService) {
        super();
        this._search$.pipe(
            tap(() => this._loading$.next(true)),
            switchMap(() => this._search()),
            tap(() => this._loading$.next(false))
        ).subscribe((result: any) => {
            // console.log(JSON.parse(this.jsonData.replace(/,\s*}/g, '}').replace(/,\s*]/g, ']'))) - used in texting with just raw json
            // this._resultItems$.next(JSON.parse(this.jsonData.replace(/,\s*}/g, '}').replace(/,\s*]/g, ']')));
            // this._total$.next(JSON.parse(this.jsonData.replace(/,\s*}/g, '}').replace(/,\s*]/g, ']')).length);
            this._resultItems$.next(result.items);
            this._total$.next(result.count);
        });
    }

    get resultItems$() { return this._resultItems$.asObservable(); }

    protected _search(): Observable<SearchResultModel<any> | undefined> {

        this.validateStartIndex();

        this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;

        return this.myFileApiService.getEmailTemplates(this._state);
    }

    clearListService() {
        this._state = { ...this.defaultEmailTemplateListState };
        this._resultItems$.next(new Array<EmailTemplateBaseModel>());
        this._total$.next(0);
    }

}
